import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useIsMobile } from '../../../../../hooks/useIsMobile';

interface NotificationTabProps {
  tab: string;
  isActive: boolean;
  onClick: (tab: string) => void;
  count?: string | number;
}

export function NotificationTab({
  tab,
  isActive,
  onClick,
  count,
}: NotificationTabProps) {
  const isMobile = useIsMobile();
  const statusClassNameDesktop = isActive
    ? 'text-white bg-clc-blue'
    : 'bg-base-content text-btn-black';

  const statusClassNameMobile = isActive
    ? 'text-clc-blue underline'
    : 'text-med-gray-3 underline';

  const statusClassName = isMobile
    ? statusClassNameMobile
    : statusClassNameDesktop;

  return (
    <div
      onClick={() => onClick(tab)}
      data-testid={`${tab}-notification-tab`}
      className={twMerge(
        statusClassName,
        'flex items-center justify-center uppercase rounded-full py-2 px-4 text-xs desktop:text-sm font-bold',
      )}
    >
      {tab}
      <span className="inline-block ml-1">{count ? `(${count})` : null}</span>
    </div>
  );
}
